import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';
import { useNavigate } from 'react-router-dom';
import Login from './Login';
import Upload from './Upload';
import Admin from './Admin';
import Wizard from './Wizard';
import ProjectList from './ProjectList';
import Dashboard from './Dashboard';
import Production from './Production';
import ForumCollaboratif from './ForumCollaboratif';
import ProjectContribute from './ProjectContribute';
import JourneyAdmin from './JourneyAdmin';
import ScenarioEditor from './ScenarioEditor';
import LandingPage from './LandingPage';
import AccountPage from './AccountPage';
import SettingsPage from './SettingsPage';
import SettingsRouter from './SettingsRouter';
import BillingPage from './BillingPage';
import BillingAdminPage from './BillingAdminPage';
import AccountSettingsPage from './AccountSettingsPage';
import UserProfilePage from './UserProfilePage';
 
import ProjectRecapWrapper from './ProjectRecapWrapper';
import Navbar from './Navbar';
import { GroupList, GroupCreate, GroupDetail } from './GroupModule';
import UserProfile from './UserProfile';
import { useParams } from 'react-router-dom';

const AppRoutes = ({ onLogout }) => {
  const location = useLocation();
  const { keycloak } = useKeycloak();
  const isAuthenticated = keycloak?.authenticated;
  const isLanding = location.pathname === '/';

  return (
   <>
  {isAuthenticated && !isLanding ? (
    <div className="d-flex">
      <Navbar onLogout={onLogout} />
      <main style={{ paddingLeft: '10px', width: '100%' }}>
        <Routes>
          {/* Toutes tes routes ici */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<RequireAuth><Login /></RequireAuth>} />
          <Route path="/upload" element={<RequireAuth><Upload /></RequireAuth>} />
          <Route path="/wizard" element={<RequireAuth><Wizard /></RequireAuth>} />
          <Route path="/projects" element={<RequireAuth><ProjectList /></RequireAuth>} />
          <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
          <Route path="/production" element={<RequireAuth><Production /></RequireAuth>} />
          <Route path="/forum" element={<RequireAuth><ForumCollaboratif /></RequireAuth>} />
          <Route path="/project/:id" element={<RequireAuth><ProjectContribute /></RequireAuth>} />
          <Route path="/project/:id/manage" element={<RequireAuth><JourneyAdmin /></RequireAuth>} />
          <Route path="/project/:id/scenario" element={<RequireAuth><ScenarioEditor /></RequireAuth>} />
          <Route path="/admin" element={<RequireAuth><Admin /></RequireAuth>} />
          <Route path="/projects/:id/recap" element={<RequireAuth><ProjectRecapWrapper /></RequireAuth>} />
          <Route path="/groups" element={<RequireAuth><GroupList /></RequireAuth>} />
          <Route path="/groups/create" element={<RequireAuth><GroupCreate /></RequireAuth>} />
          <Route path="/groups/:groupId" element={<RequireAuth><GroupDetailWrapper /></RequireAuth>} />
          <Route path="/users/:username" element={<RequireAuth><UserProfileWrapper /></RequireAuth>} />
          <Route path="/account" element={<RequireAuth><AccountPage /></RequireAuth>} />
          <Route path="/settings" element={<RequireAuth><SettingsPage /></RequireAuth>} />
          <Route path="/billing" element={<RequireAuth><BillingPage /></RequireAuth>} />
          <Route path="/admin/billing" element={<RequireAuth><BillingAdminPage /></RequireAuth>} />
          <Route path="/settings/account" element={<AccountSettingsPage />} />
          <Route path="/users/:username" element={<UserProfilePage />} />
        </Routes>
      </main>
    </div>
  ) : (
    <Routes>
      <Route path="/" element={<LandingPage />} />
    </Routes>
  )}
</>

  );
};

// ✅ Wrapper pour les routes privées
function RequireAuth({ children }) {
  const navigate = useNavigate();
  const location = useLocation(); // 🔁 Ajout pour éviter erreur undefined
  const { keycloak, initialized } = useKeycloak();

  useEffect(() => {
    if (initialized && !keycloak?.authenticated) {
      keycloak.login({
        redirectUri: window.location.origin + '/dashboard' // ✅ one-time login redirection
      });
    }
  }, [initialized, keycloak]);


  if (!initialized) {
    return <div></div>;
  }

  if (!keycloak?.authenticated) {
    keycloak.login({ redirectUri: window.location.origin + '/dashboard' })
  }

  return children;
}
// Wrappers pour injecter les paramètres d’URL
const GroupDetailWrapper = () => {
  const { groupId } = useParams();
  return <GroupDetail groupId={groupId} />;
};

const UserProfileWrapper = () => {
  const { username } = useParams();
  return <UserProfile username={username} />;
};
export default AppRoutes;
